import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";


type AlertProps = {
  message: string;
};

export const WarningAlert: React.FC<AlertProps> = ({ message }) => {
  return (
    <div
      className="
        my-4
        flex items-center
        rounded
        border-l-4 border-amber-500
        bg-amber-900/90
        p-4
        text-sm
        text-gray-200
        shadow-md
      "
      role="alert"
    >
      <FaExclamationTriangle className="mr-2 text-amber-400 text-xl hidden md:block" />
      <span
        className="leading-relaxed"
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>
  );
};